"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Statistic = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var coupon_1 = require("../../model/coupon");
var service_1 = require("../../../library/base/service");
var Statistic = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Statistic, _super);
    function Statistic() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '数据统计';
        _this.code = '300302';
        _this.desc = '数据统计';
        _this.requestParams = new coupon_1.StatisticRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return Statistic;
}(service_1.BaseService));
exports.Statistic = Statistic;
//# sourceMappingURL=statistic.js.map